import React from 'react'
import PropTypes from 'prop-types'
import StartDateInput from 'components/StartDateInput'
import {
  ProgramStartDateLabel,
  ProgramStartDateWrapper,
} from './component.styles'
import { ModalHeader } from 'components/ModalElements/component.styles'

const AddProgramStartDate = ({
  errors,
  handleChange,
  modalData,
  values,
  touched,
}) => {
  const { bodyCopy, header, choiceContent = [] } = modalData || {}
  const content = choiceContent[0] || {}

  return (
    <ProgramStartDateWrapper>
      <ModalHeader>{header}</ModalHeader>
      <ProgramStartDateLabel>{bodyCopy}</ProgramStartDateLabel>
      <StartDateInput
        date={values?.programStartDate}
        description={content.bodyCopy}
        error={errors?.programStartDate}
        handleChange={handleChange}
        inputLabel={'Target Date'}
        name={'programStartDate'}
        title={content.header}
        touched={touched?.programStartDate}
      />
    </ProgramStartDateWrapper>
  )
}

AddProgramStartDate.propTypes = {
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleContinueButtonClick: PropTypes.func,
  modalData: PropTypes.shape({
    header: PropTypes.string,
    helpCopy: PropTypes.string,
    image: PropTypes.object,
    nextLabel: PropTypes.string,
  }),
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default AddProgramStartDate
